<template>
  <div
    :class="isAdmin ? 'box' : ''"
    :style="
      isAdmin ? 'background-color:hsl(0, 0%, 96%)' : 'background-color: white'
    "
  >
    <section>
      <div class="field">
        <div class="control">
          <input type="text" v-model="suite.name" class="input is-medium" />
        </div>
      </div>
      <div class="columns">
        <div class="column is-2">
          <div class="field" v-show="suite.name">
            <label class="image is-square show-icon-hover">
              <span class="icon icon-right is-small"
                ><i class="fas fa-pen-square"></i
              ></span>
              <img
                :src="fixHttpProtocol(suite.logo_path)"
                class="company-logo"
              />
              <input
                type="file"
                ref="newLogo"
                @change="uploadLogo($refs.newLogo.files[0], suite)"
                style="display: none"
              />
            </label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <textarea
              class="textarea"
              v-model="suite.description"
              placeholder="Enter suite description"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="columns" v-if="isAdmin">
        <div class="column">
          <div class="field">
            <div class="label">
              Add Contacts
              <button
                @click="syncContacts()"
                title="Re-sync Contacts"
                class="button is-pulled-right"
                :class="{ 'is-loading': spinnerForResync }"
              >
                <span class="icon"><i class="fas fa-sync-alt"></i></span>
              </button>
            </div>
            <div class="control">
              <multiselect
                v-model="suite.contacts"
                :options="companyContacts"
                :multiple="true"
                :close-on-select="false"
                :searchable="true"
                :hide-selected="true"
                track-by="id"
                label="name"
                :custom-label="customContactLabel"
              >
                <template slot="tag" slot-scope="props">
                  <span class="multiselect__tag" @mousedown.prevent>
                    <span
                      v-show="!props.option.is_primary && props.option.email"
                      :title="
                        `Assign ${props.option.name} as the primary contact.`
                      "
                    >
                      <span
                        class="icon"
                        @mousedown.prevent="togglePrimary(props.option)"
                        ><i class="far fa-star"></i
                      ></span>
                    </span>
                    <span
                      v-show="props.option.is_primary && props.option.email"
                      :title="`${props.option.name} is the primary contact.`"
                    >
                      <span
                        class="icon"
                        @mousedown.prevent="togglePrimary(props.option)"
                        ><i class="fas fa-star"></i
                      ></span>
                    </span>
                    <span
                      v-show="!props.option.email != ''"
                      :title="
                        `No Email, ${props.option.name} cant' be assigned primary contact.`
                      "
                    >
                      <span class="icon"
                        ><i class="fa fa-exclamation-triangle"></i
                      ></span>
                    </span>
                    <span v-text="props.option.name"></span>
                    <i
                      aria-hidden="true"
                      tabindex="1"
                      class="multiselect__tag-icon"
                      @click="props.remove(props.option)"
                    ></i>
                  </span>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="columns" v-if="isAdmin">
        <div class="help column has-text-left">
          Can't find a contact?
          <a
            :href="
              maxxIntranetDomain +
                '/membership/IndividualFormPrivate/edit?companyId=' +
                this.companyId
            "
            target="_blank"
            >Click here</a
          >
          to add it to the database. After it has been added, click the refresh
          button above to pull the new contact into this list.
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { storage } from '@/services/firebase';
import { convertToKebabCase, fixHttpProtocol } from '@/services/utils';

export default {
  data() {
    return {
      maxxIntranetDomain: process.env.MAXX_INTRANET_DOMAIN,
      spinnerForResync: false
    };
  },
  props: {
    suite: {
      type: Object
    },
    companyContacts: {
      type: Array,
      required: false,
      default: () => []
    },
    isAdmin: {
      type: Boolean,
      required: true
    },
    companyId: {
      type: String,
      required: false,
      default: ''
    }
  },
  watch: {
    companyContacts: function(newCompanyContacts, oldCompanyContacts) {
      this.suite.contacts = this.suite.contacts.filter(suiteContact => {
        let foundContact = false;
        for (let companyContact of newCompanyContacts) {
          if (companyContact.id === suiteContact.id) {
            suiteContact.email = companyContact.email;
            suiteContact.name = companyContact.name;
            suiteContact.username = companyContact.username;
            foundContact = true;
            break;
          }
        }
        return foundContact;
      });
    }
  },
  methods: {
    fixHttpProtocol,
    togglePrimary(contactIn) {
      this.suite.contacts = [...this.suite.contacts].map(contact => {
        if (contactIn.id === contact.id) {
          contact.is_primary = !contact.is_primary;
        }
        return contact;
      });
    },
    syncContacts() {
      this.$emit('syncContacts');
      this.spinnerForResync = true;
      setTimeout(() => {
        this.spinnerForResync = false;
      }, 300);
    },
    uploadLogo(file, suite) {
      const ref = storage.ref();
      const name =
        'logos/' +
        convertToKebabCase(suite.name) +
        '-' +
        +new Date() +
        '-' +
        file.name;
      const metadata = { contentType: file.type };
      const task = ref.child(name).put(file, metadata);

      // display the new logo immediately
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function() {
          suite.logo_path = reader.result;
        },
        false
      );
      reader.readAsDataURL(file);

      task.then(snapshot => {
        snapshot.ref.getDownloadURL().then(downloadURL => {
          suite.logo_path = downloadURL;
        });
      });
    },
    customContactLabel({ name, email }) {
      return email !== '' ? `${name} (${email})` : `${name} (no email)`;
    }
  },
  components: {
    Multiselect
  }
};
</script>

<style scoped>
.show-icon-hover {
  position: relative;
  cursor: pointer;
}

span.icon-right {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  transition: opacity 0.2s linear;
}

.show-icon-hover:hover span.icon-right {
  opacity: 1;
}

.is-contact {
  background-color: rgba(0, 0, 0, 0.15);
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/EditSuite.vue